<template>
    <div class="rounded-xl bg-base-100 shadow-2xl flex flex-col p-2">
        <slot/>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";


:slotted(.tile-link) {
    @apply flex items-center btn-sm gap-1 p-2 rounded underline hover:text-primary hover:font-semibold absolute bottom-6 right-4;
}

</style>